import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _typeof from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { rechargeProducPenetrationRateCurrency, rechargeProducPenetrationRate } from "@/api/dataAll/userSegmentationGrowth";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "tieredUserFirstThree",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      deviceList: [{
        label: "新增账号",
        id: "user"
      }],
      paramsData: {
        dimension_kind: "user",
        penetration: 3
      },
      tableList: [],
      serverList: [],
      levelList: []
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    levelChange: function levelChange(e) {
      if (!e) {
        this.paramsData.recharge_levels = '';
      }
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      this.tableList = [];
      this.tableData = [];

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      if (!this.paramsData.dimension_kind) {
        this.$message.error('请选择新增设备或新增账号');
        return;
      }

      if (this.levelItem == '1' && !this.paramsData.recharge_levels) {
        this.$message.error('请输入层级');
        return;
      }

      if (/，/.test(this.paramsData.recharge_levels)) {
        this.$message.error('请输入英文的逗号');
        return;
      }

      this.reqLoading = true;
      var params = {
        dimension_kind: this.paramsData.dimension_kind,
        game_id: this.searchData.game_id,
        // special_product_id: this.searchData.special_product_id,
        starttime: this.searchData.starttime,
        endtime: this.searchData.endtime,
        server_id: this.paramsData.server_id,
        recharge_levels: this.paramsData.recharge_levels,
        penetration: this.paramsData.penetration
      }; //判断是否有货币

      var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
      var reqFn = searchCurrency.length ? rechargeProducPenetrationRateCurrency : rechargeProducPenetrationRate;
      reqFn(params).then(function (res) {
        if (res.code == 200) {
          var _ret = function () {
            if (!res.data) {
              return {
                v: void 0
              };
            }

            var data = res.data;
            var tier_config = res.tier_config;
            var product_id_arr = res.product_id_arr; // 初始化 tableData - 为每个层级创建一个对象

            _this2.tableData = Object.keys(tier_config).map(function (level) {
              return {
                level: level,
                // 添加付费金额范围（从 tier_config 的 range 字段获取）
                recharge_range: tier_config[level].range,
                label: tier_config[level].label
              };
            }); // 获取所有的购买次数（从数据中动态获取）

            var allPurchaseTimes = new Set();

            for (var date in data) {
              for (var level in data[date]) {
                if (data[date][level].purchase_stats) {
                  Object.keys(data[date][level].purchase_stats).forEach(function (time) {
                    allPurchaseTimes.add(time);
                  });
                }
              }
            } // 转换为数组并排序


            var purchaseTimes = Array.from(allPurchaseTimes).sort(function (a, b) {
              return a - b;
            }); // 处理表格表头

            _this2.tableList = [{
              label: "",
              prop: "recharge_range",
              list: [{
                label: "付费金额",
                prop: "recharge_range",
                level: "all"
              }]
            }];

            var _loop = function _loop(_date) {
              var dateItem = {
                label: _date,
                prop: _date,
                list: []
              }; // 添加付费人数列

              dateItem.list.push({
                label: "付费人数",
                prop: "".concat(_date, "-user_count"),
                level: "all" // 特殊标记，不是具体层级

              }); // 添加购买次数列（动态生成）

              purchaseTimes.forEach(function (time) {
                var timesItem = {
                  label: "\u6B21\u6570".concat(time),
                  prop: time,
                  level: "all",
                  // 特殊标记，不是具体层级
                  list: [{
                    label: "商品总数",
                    prop: "".concat(_date, "-").concat(time, "-total")
                  }]
                }; // 添加每个商品的列

                product_id_arr.forEach(function (productId) {
                  timesItem.list.push({
                    label: productId.toString(),
                    prop: "".concat(_date, "-").concat(time, "-").concat(productId)
                  });
                });
                dateItem.list.push(timesItem);
              });

              _this2.tableList.push(dateItem);
            };

            for (var _date in data) {
              _loop(_date);
            } // 填充表格数据


            _this2.tableData.forEach(function (row) {
              var level = row.level;

              _this2.tableList.forEach(function (dateColumn) {
                var date = dateColumn.prop;
                if (date === "recharge_range") return; // 处理付费人数

                if (data[date] && data[date][level]) {
                  row["".concat(date, "-user_count")] = data[date][level].user_count || 0;
                } else {
                  row["".concat(date, "-user_count")] = 0;
                } // 处理购买次数数据


                purchaseTimes.forEach(function (time) {
                  // 商品总数
                  var totalProp = "".concat(date, "-").concat(time, "-total");

                  if ( // data[date] && 
                  //   data[date][level] && 
                  //   data[date][level].purchase_stats && 
                  data[date][level].purchase_stats[time]) {
                    row[totalProp] = data[date][level].purchase_stats[time].total || 0;
                  } else {
                    row[totalProp] = 0;
                  } // 各个商品的数据


                  product_id_arr.forEach(function (productId) {
                    var productProp = "".concat(date, "-").concat(time, "-").concat(productId);

                    if (_typeof(data[date][level].purchase_stats[time].products) === 'object' && data[date][level].purchase_stats[time].products[productId]) {
                      // 提取数量部分（格式为 "1/100%"）
                      var productData = data[date][level].purchase_stats[time].products[productId];
                      row[productProp] = productData || '0';
                    } else if (data[date][level].purchase_stats[time].products === "") {
                      // 处理空字符串的情况
                      row[productProp] = '0';
                    } else {
                      row[productProp] = '0';
                    }
                  });
                });
              });
            });

            console.log("tableData=====", _this2.tableData);
            console.log("tableList=====", _this2.tableList);
          }();

          if (_typeof(_ret) === "object") return _ret.v;
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [];
      var d = {};
      this.tableList.forEach(function (item, index) {
        item.list && item.list.forEach(function (items, indexs) {
          items.list && items.list.forEach(function (itema, indexs) {
            columns.push({
              label: items.label,
              prop: itema.prop
            });
            d[itema.prop] = itema.label;
          });
        });
      });
      var data = JSON.parse(JSON.stringify(this.tableData));
      data.unshift(d);
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};